




import { logout } from '@antriver/vue-site-utils/src/util/auth';
import Vue from 'vue';
import { api, authTokenStore } from '@/services/api';

export default Vue.extend({
    name: 'LogoutView',

    mounted() {
        logout(api, this.$store, authTokenStore);
        this.$router.replace('/');
    },
});
